import {Inject, Injectable} from '@angular/core';
import {HttpBackend, HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {COMMON_LIB_CONFIG_TOKEN, ICommonLibConfig} from '../../common-lib-config';
import {Alert} from '../../util/alert';

@Injectable({
  providedIn: 'root'
})
export class BypassHttpService {
  private httpClient: HttpClient;

  constructor(handler: HttpBackend,
              @Inject(COMMON_LIB_CONFIG_TOKEN) private config: ICommonLibConfig) {
    this.httpClient = new HttpClient(handler);
  }

  request<R, P>(method: 'get' | 'post' | 'patch' | 'delete' | 'put', url: string, options: {
    body?: P;
    headers?: HttpHeaders | {
      [header: string]: string | string[];
    };
    params?: HttpParams | {
      [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
    };
  }): Observable<R> {
    return this.httpClient.request<R>(method, `${this.config.apiUrl}${url}`, {...options, ...{responseType: 'json'}})
      .pipe(
        catchError((response) => {
          if (response instanceof HttpErrorResponse) {
            const httpErrorResponse = response as HttpErrorResponse;
            const detail = httpErrorResponse.error?.message || httpErrorResponse.message;
            Alert.message({
              severity: 'error',
              summary: 'Response Error',
              detail: detail,
              life: 10000
            });
          }
          return throwError(response);
        })
      );
  }
}

